// Auto-generated from JVF DTM 1.5.0.1 XSD — DO NOT EDIT
// Run: npx tsx scripts/generate-types.ts <version>
//
// ENUM_LABELS: název číselníkového atributu → { kód → český popisek }.
// BOOLEAN_ATTRS: názvy xs:boolean atributů (v XML 0/1) — hodnotu překládá
//   labelForAttribute na ano/ne (nejsou to číselníky, drženy zvlášť).
export const ENUM_LABELS = {
    "UrovenUmisteniObjektuZPS": {
        "-3": "3. úroveň pod povrchem (nejníže)",
        "-2": "2. úroveň pod povrchem",
        "-1": "1. úroveň pod povrchem",
        "0": "na povrchu",
        "1": "1. úroveň nad povrchem",
        "2": "2. úroveň nad povrchem",
        "3": "3. úroveň nad povrchem (nejvýše)",
    },
    "UrovenUmisteniObjektuTI": {
        "-1": "pod povrchem",
        "0": "na povrchu",
        "1": "nad povrchem",
    },
    "UrovenUmisteniObjektuDI": {
        "-3": "3. úroveň pod povrchem (nejníže)",
        "-2": "2. úroveň pod povrchem",
        "-1": "1. úroveň pod povrchem",
        "0": "na povrchu",
        "1": "1. úroveň nad povrchem",
        "2": "2. úroveň nad povrchem",
        "3": "3. úroveň nad povrchem (nejvýše)",
    },
    "UrovenUmisteniObjektuPSPI": {
        "-1": "pod povrchem",
        "0": "na povrchu",
        "1": "nad povrchem",
    },
    "PrevazujiciPovrch": {
        "1": "asfalt",
        "2": "beton",
        "3": "dlažba",
        "4": "R-materiál",
        "5": "písek, štěrkopísek",
        "6": "šotolina",
        "7": "nezpevněno",
        "8": "zpevněný propustný",
        "99": "nezjištěno",
    },
    "KategoriePozemniKomunikace": {
        "1": "dálnice I. třídy",
        "2": "dálnice II. třídy",
        "3": "silnice I. třídy",
        "4": "silnice II. třídy",
        "5": "silnice III. třídy",
        "6": "místní komunikace I. třídy",
        "7": "místní komunikace II. třídy",
        "8": "místní komunikace III. třídy",
        "9": "místní komunikace IV. třídy",
        "10": "účelová komunikace",
        "11": "neveřejně přístupná účelová komunikace",
        "99": "nezjištěno",
    },
    "TypUsekuPozemniKomunikace": {
        "1": "zemní těleso komunikace",
        "2": "most",
        "3": "tunel",
        "4": "přesypaný most",
        "99": "nezjištěno",
    },
    "TypPozemniKomunikace": {
        "1": "komunikace",
        "2": "okružní křižovatka",
        "3": "prostranství bezprostředně sloužící provozu a údržbě pozemní komunikace",
        "99": "nezjištěno",
    },
    "TypObjektuSilnicniDopravyZameru": {
        "1": "dálnice",
        "2": "silnice",
        "3": "místní komunikace",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypObjektuSilnicniDopravyPS": {
        "1": "dálnice",
        "2": "silnice",
        "3": "místní komunikace",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypDrahy": {
        "1": "železniční",
        "2": "tramvajová",
        "3": "lanová",
        "4": "speciální",
        "5": "trolejbusová",
        "99": "nezjištěno/neurčeno",
    },
    "TypUsekuZeleznicniTrate": {
        "1": "zemní těleso",
        "2": "most",
        "3": "tunel",
        "99": "nezjištěno",
    },
    "KategorieZeleznicniTrate": {
        "1": "celostátní",
        "2": "regionální",
        "3": "místní",
        "4": "vlečka",
        "5": "zkušební",
        "98": "jiná",
        "99": "nezjištěno/neurčeno",
    },
    "TypZeleznicniTrate": {
        "1": "vysokorychlostní",
        "2": "konvenční",
        "99": "nezjištěno/neurčeno",
    },
    "ElektrizaceZeleznicniTrate": {
        "1": "elektrizovaná",
        "2": "neelektrizovaná",
        "99": "nezjištěno",
    },
    "ZpusobPorizeniDI": {
        "1": "geodeticky - terestricky",
        "2": "geodeticky - fotogrammetricky",
        "3": "geodeticky - pozemním laserovým skenováním",
        "4": "přibližným zákresem",
        "5": "odvozením",
        "6": "geodeticky - technologií GNSS",
        "99": "nezjištěno",
    },
    "RozchodKoleji": {
        "1": "1435 mm",
        "2": "760 mm",
        "3": "splítka",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "DruhDopravyLanoveDrahy": {
        "1": "nákladní",
        "2": "osobní",
        "99": "nezjištěno",
    },
    "ZpusobPorizeniZPS": {
        "1": "geodeticky - terestricky",
        "2": "geodeticky - fotogrammetricky",
        "3": "geodeticky - pozemním laserovým skenováním",
        "4": "přibližným zákresem",
        "5": "odvozením",
        "6": "geodeticky - technologií GNSS",
        "99": "nezjištěno",
    },
    "ZpusobPorizeniPB_ZPS": {
        "1": "geodeticky - terestricky",
        "2": "geodeticky - fotogrammetricky",
        "3": "geodeticky - pozemním laserovým skenováním",
        "4": "přibližným zákresem",
        "5": "konstrukčně",
        "6": "geodeticky - technologií GNSS",
        "7": "geodeticky - technologií GNSS před záhozem",
        "8": "geodeticky - technologií GNSS po záhozu",
        "9": "geodeticky - terestricky před záhozem",
        "10": "geodeticky - terestricky po záhozu",
        "11": "vyhledáním",
        "99": "nezjištěno",
    },
    "TypDopravneVyznamnehoMistaDraze": {
        "1": "stanice",
        "2": "zastávka",
        "3": "odbočka",
        "4": "nákladiště",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "ZarazeniSledovaneVodniCesty": {
        "1": "dopravně významná využívaná",
        "2": "dopravně významná využitelná",
        "3": "účelová",
        "4": "plánovaná",
    },
    "TridaDopravneVyznamneVodniCesty": {
        "1": "místního významu třídy 0",
        "2": "místního významu třídy I",
        "3": "mezinárodního významu třídy IV",
        "4": "mezinárodního významu třídy Va",
        "5": "mezinárodního významu třídy Vb",
    },
    "TypSledovaneVodniCesty": {
        "1": "vedená řekou",
        "2": "vedená plavebním kanálem",
        "98": "jiná vodní plocha",
    },
    "TypPristavu": {
        "1": "veřejný",
        "2": "neveřejný",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "TypPovrchuVzletovePristavaciDrahy": {
        "1": "asfaltobeton",
        "2": "cementobeton",
        "3": "tráva",
        "99": "nezjištěno",
    },
    "DruhLetiste": {
        "1": "veřejné s vnitrostátním provozem",
        "2": "veřejné s mezinárodním provozem",
        "3": "neveřejné s vnitrostátním provozem",
        "4": "neveřejné s mezinárodním provozem",
        "5": "vojenské",
        "99": "nezjištěno",
    },
    "UmisteniHeliportu": {
        "1": "úrovňový",
        "2": "vyvýšený",
        "99": "nezjištěno",
    },
    "TypLeteckeStavby": {
        "1": "podzemní",
        "2": "pojezdová dráha",
        "3": "odbavovací plocha",
        "4": "manipulační plocha",
        "5": "odbavovací budova",
        "6": "hangár",
        "98": "jiná",
    },
    "TypZarizeniProLeteckyProvoz": {
        "1": "přehledový systém",
        "2": "radionavigační zařízení",
        "3": "radiokomunikační systém",
        "4": "světelné zařízení",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "TypMostu": {
        "1": "silniční",
        "2": "železniční",
        "3": "pro vodní dopravu",
        "4": "lávka pro pěší a cyklisty",
        "5": "přechod pro volně žijící živočichy",
        "6": "sdružený",
        "99": "nezjištěno",
    },
    "TypTunelu": {
        "1": "železniční",
        "2": "silniční",
        "3": "pro cyklisty a chodce",
        "4": "pro vodní dopravu",
        "5": "sdružený",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "TypNabijecihoVydejnihoMedia": {
        "1": "nabíjení elektromobilních zařízení (vč. plavidel)",
        "2": "CNG",
        "3": "LPG",
        "4": "LNG",
        "5": "benzín/nafta",
        "6": "vodík",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "TypSvodidla": {
        "1": "jednoduché",
        "2": "zdvojené",
        "99": "nezjištěno",
    },
    "TypNadrzeZdrzeSeVzdouvacimObjektem": {
        "1": "vodní nádrž",
        "6": "vyrovnávací nádrž",
        "7": "jezová zdrž",
        "98": "jiná",
        "99": "nezjištěno",
    },
    "TypNadrzeBezVzdouvacihoObjektu": {
        "1": "retenční",
        "2": "dešťová",
        "3": "usazovací",
        "98": "jiná",
        "99": "nezjištěno",
    },
    "ZpusobPorizeniTI": {
        "1": "geodeticky - terestricky",
        "2": "geodeticky - terestricky před záhozem",
        "3": "geodeticky - terestricky po záhozu",
        "4": "geodeticky - fotogrammetricky",
        "5": "geodeticky - pozemním laserovým skenováním",
        "6": "přibližným zákresem",
        "7": "vyhledáním",
        "8": "odvozením",
        "9": "geodeticky - technologií GNSS",
        "10": "geodeticky - technologií GNSS před záhozem",
        "11": "geodeticky - technologií GNSS po záhozu",
        "99": "nezjištěno",
    },
    "DruhMelioracnichOpatreni": {
        "1": "odvodnění",
        "2": "závlaha",
        "3": "opatření proti vodní erozi - příkop",
        "4": "opatření proti vodní erozi - průleh",
        "5": "opatření proti větrné erozi",
        "6": "revitalizace půdy",
        "7": "vsakovací objekt",
        "99": "nezjištěno",
    },
    "TypProtipovodnoveZabrany": {
        "1": "hráz",
        "3": "zeď",
        "4": "stavební základy mobilní zábrany",
        "98": "jiná",
    },
    "TypObjektuZarizeniOchranaPredPovodnemi": {
        "1": "hradítko hradidlové šachty",
        "2": "hrazení, uzávěr, vrata",
        "3": "patka protipovodňové stěny",
        "4": "odlehčovací koryto",
        "98": "jiný",
    },
    "TypObjektuOdvodneniStavby": {
        "1": "liniový odvodňovač",
        "2": "vpusť kanalizační sítě",
        "3": "odtokové potrubí",
        "4": "vsakovací jímka",
        "98": "jiný",
    },
    "StavObjektu": {
        "1": "provozováno",
        "2": "neprovozováno",
        "99": "nezjištěno",
    },
    "TypTechnickehoKanalu": {
        "4": "chránička",
        "5": "kabelovod",
        "6": "technický podpovrchový kanál",
        "7": "kabelová lávka / žlab",
        "98": "jiná ochranná konstrukce",
        "99": "nezjištěno",
    },
    "TypSdilenehoObjektuTI": {
        "1": "sdružená rozvodná skříň",
        "5": "šachta vstupní",
        "6": "šachta kabelová",
        "7": "odbočka",
        "8": "technická komora",
        "9": "inspekční komora",
        "10": "kabelová komora",
        "11": "armaturní komora",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "TypPodpernehoZarizeni": {
        "1": "stožár příhradový",
        "4": "sloup trakčního vedení",
        "5": "nástěnná konzola",
        "6": "střešník",
        "7": "portál",
        "8": "hák",
        "9": "stožár jiný",
        "10": "sloup elektrického veřejného osvětlení",
        "11": "sloup plynového veřejného osvětlení",
        "12": "sloup jiný",
    },
    "TypSloupu": {
        "1": "betonový",
        "2": "dřevěný",
        "3": "kovový",
        "99": "nezjištěno",
    },
    "StavTrasySiteTI": {
        "1": "provozováno",
        "2": "neprovozováno",
        "3": "zrušeno",
        "99": "nezjištěno",
    },
    "VedeniSiteVJineStavbe": {
        "1": "kolektor",
        "2": "technický kanál",
        "3": "teplovod",
        "4": "kanalizace",
        "5": "tunel",
        "6": "most",
        "7": "portál",
        "97": "jiná stavba",
        "98": "nevede v jiné stavbě",
        "99": "nezjištěno",
    },
    "TypTrasyElektrickeSite": {
        "1": "silové vedení",
        "2": "zemnící lano",
        "3": "zemnič",
        "99": "nezjištěno",
    },
    "MaximalniNapetovaHladina": {
        "0": "uzemnění",
        "1": "NN",
        "2": "VN",
        "3": "VVN",
        "4": "ZVN",
        "5": "UVN",
        "99": "nezjištěno/neurčeno",
    },
    "MaximalniProvozniNapeti": {
        "0": "uzemnění",
        "1": "0,4 kV",
        "2": "0,5 kV",
        "3": "3 kV",
        "4": "5 kV",
        "5": "6 kV",
        "6": "10 kV",
        "7": "22 kV",
        "8": "35 kV",
        "9": "110 kV",
        "10": "220 kV",
        "11": "400 kV",
        "12": "0,11 kV",
        "13": "0,23 kV",
        "14": "0,6 kV",
        "15": "0,75 kV",
        "16": "1,5 kV",
        "17": "15 kV",
        "18": "25 kV",
        "19": "2x25 kV",
        "20": "800 kV",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "DruhElektrickehoProudu": {
        "1": "AC",
        "2": "DC",
        "3": "AC/DC",
    },
    "DruhElektrickehoProuduTrakcnihoVedeni": {
        "1": "AC",
        "2": "DC",
        "99": "nezjištěno",
    },
    "IzolaceVenkovnihoVedeni": {
        "1": "základní",
        "2": "bez izolace",
        "99": "nezjištěno",
    },
    "TypTrasyMistniElektrickeSite": {
        "1": "veřejné osvětlení",
        "2": "světelná signalizace",
        "4": "osvětlovací síť staveb",
        "99": "nezjištěno",
    },
    "TypZarizeniElektrickeSite": {
        "1": "skříň elektrické sítě",
        "98": "jiné",
    },
    "TypVyrobnyElektriny": {
        "1": "geotermální",
        "2": "jaderná",
        "3": "vodní",
        "4": "fotovoltaická",
        "5": "tepelná",
        "6": "větrná",
        "7": "bioplynová",
        "99": "nezjištěno",
    },
    "TypObjektuElektrickeSiteZameru": {
        "1": "geotermální elektrárna",
        "2": "jaderná elektrárna",
        "3": "vodní elektrárna",
        "4": "fotovoltaická elektrárna",
        "5": "tepelná elektrárna",
        "6": "větrná elektrárna",
        "7": "bioplynová elektrárna",
        "8": "stanice elektrické sítě",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypObjektuElektrickeSitePS": {
        "1": "geotermální elektrárna",
        "2": "jaderná elektrárna",
        "3": "vodní elektrárna",
        "4": "fotovoltaická elektrárna",
        "5": "tepelná elektrárna",
        "6": "větrná elektrárna",
        "7": "bioplynová elektrárna",
        "8": "stanice elektrické sítě",
        "9": "trasa elektrické sítě",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypStaniceElektrickeSite": {
        "1": "transformační stanice",
        "2": "stanice distribuční soustavy",
        "3": "spínací stanice",
        "4": "měnírna",
        "5": "stanice přenosové soustavy",
        "6": "trakční napájecí stanice",
        "98": "jiná",
    },
    "DruhStaniceElektrickeSite": {
        "1": "kompaktní a zděná",
        "2": "stožárová",
        "3": "věžová",
        "4": "venkovní",
        "5": "vestavěná",
        "99": "nezjištěno",
    },
    "TypJadernehoZarizeni": {
        "1": "reaktor",
        "2": "sklad",
        "3": "úložiště",
        "98": "jiné",
    },
    "MaterialTrasySiteEK": {
        "1": "metalická",
        "2": "optická",
        "3": "metalická + optická",
        "99": "nezjištěno",
    },
    "ZpusobOchranyVedeniSiteEK": {
        "1": "bez ochrany vedení",
        "2": "plastová trubka",
        "3": "svazek mikrotrubiček",
        "99": "nezjištěno",
    },
    "TypZarizeniSiteEK": {
        "2": "venkovní rozvaděč EK",
        "3": "bod pro přístup nebo propojení sítí EK uvnitř budov",
    },
    "UmisteniObjektu": {
        "1": "samostatně stojící",
        "2": "na objektu",
        "99": "nezjištěno",
    },
    "TypTechnologickehoObjektuSiteEK": {
        "1": "radioteleskop",
        "2": "technologická budova EK",
        "3": "telekomunikační věž",
        "4": "technologický kontejner sítě EK",
    },
    "TlakovaHladinaPlynovodniSite": {
        "1": "NTL",
        "2": "STL",
        "3": "VTL",
        "4": "VVTL",
        "99": "nezjištěno/neurčeno",
    },
    "TypZarizeniPlynovodniSite": {
        "1": "šoupě",
        "2": "skříň",
        "4": "šachta",
        "98": "jiné",
    },
    "TypTechnologickehoObjektuPlynovodniSite": {
        "1": "kompresní stanice",
        "2": "regulační stanice",
        "3": "distribuční regulátor",
        "4": "odorizační stanice",
        "5": "výrobna plynu",
        "6": "stanice katodové ochrany",
        "7": "podzemní zásobník plynu",
        "8": "plnírna plynu",
        "10": "armaturní uzel",
        "11": "nadzemní zásobník plynu",
        "12": "pomocné rozvody",
        "13": "sonda",
        "98": "jiný",
    },
    "TypObjektuPlynovodniSiteZameru": {
        "1": "výrobna plynu",
        "2": "stanice",
        "3": "zásobník plynu",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypObjektuPlynovodniSitePS": {
        "1": "výrobna plynu",
        "2": "stanice",
        "3": "zásobník plynu",
        "4": "trasa plynovodní sítě",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypPodzemnihoZasobnikuPlynu": {
        "1": "sonda",
        "2": "sběrné středisko",
        "3": "centrální areál",
    },
    "TypTrasyVodovodniSite": {
        "1": "přiváděcí řad",
        "2": "rozvodná vodovodní síť",
        "98": "jiná",
        "99": "nezjištěno",
    },
    "TypMediaVodovodniSite": {
        "1": "voda pitná",
        "2": "voda surová",
        "3": "voda užitková",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "TypZarizeniVodovodniPripojky": {
        "2": "šachta měrná a kontrolní",
        "98": "jiné",
    },
    "TypObjektuVodovodniSite": {
        "1": "vodojem věžový",
        "2": "vodojem zemní",
        "3": "úpravna vody",
        "4": "čerpací stanice",
        "5": "šachta vodovodní sítě",
        "6": "pítko",
        "98": "jiný",
    },
    "TypObjektuVodovodniSitePS": {
        "1": "zdroj vody",
        "2": "vodojem",
        "3": "úpravna vody",
        "4": "trasa vodovodní sítě",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypObjektuVodovodniSiteZameru": {
        "1": "zdroj vody",
        "2": "vodojem",
        "3": "úpravna vody",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypPrivadece": {
        "1": "odkrytý",
        "2": "trubní",
        "3": "štola",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "TypZarizeniPrivadece": {
        "1": "šachta",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "TypTrasyStokoveSite": {
        "1": "stoková síť",
        "4": "přiváděcí stoka",
        "98": "jiná",
        "99": "nezjištěno",
    },
    "UceloveZarazeniStokoveSite": {
        "1": "jednotná",
        "2": "srážková",
        "3": "splašková",
        "6": "průmyslová",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "DruhStokoveSite": {
        "1": "gravitační",
        "2": "tlaková",
        "3": "podtlaková",
        "99": "nezjištěno",
    },
    "TypZarizeniKanalizacniPripojky": {
        "1": "revizní šachta",
        "2": "měrná šachta",
        "3": "domovní čerpací stanice",
        "4": "vsakovací zařízení s přepadem",
        "98": "jiné",
    },
    "TypObjektuStokoveSite": {
        "1": "čistírna odpadních vod",
        "2": "čerpací stanice",
        "3": "komora odlehčovací",
        "4": "komora jiná",
        "5": "kanalizační výusť",
        "6": "retenční nádrž na stokové síti",
        "7": "podtlaková stanice",
        "8": "šachta kanalizační",
        "9": "odlučovač lehkých kapalin",
        "98": "jiný",
    },
    "TypObjektuStokoveSiteZameru": {
        "1": "čistírna odpadních vod",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypObjektuStokoveSitePS": {
        "1": "čistírna odpadních vod",
        "2": "trasa stokové sítě",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypZarizeniSiteProduktovodu": {
        "1": "šachta",
        "99": "nezjištěno",
    },
    "TypTrasyTeplovodniSite": {
        "1": "primární",
        "2": "sekundární",
        "99": "nezjištěno",
    },
    "TypTeplovodniSite": {
        "1": "teplovod",
        "2": "horkovod",
        "3": "parovod",
        "99": "nezjištěno",
    },
    "TypZarizeniTeplovodniSite": {
        "1": "odvětrávání teplovodu",
        "2": "šachta",
        "98": "jiné",
    },
    "TypTechnologickehoObjektuTeplovodniSite": {
        "1": "teplárna",
        "2": "kotelna",
        "98": "jiný",
        "99": "nezjištěno/neurčeno",
    },
    "TypObjektuTeplovodniSitePS": {
        "1": "teplárna",
        "2": "kotelna",
        "3": "trasa teplovodní sítě",
        "98": "jiný",
        "99": "neurčeno",
    },
    "TypZarizeniPotrubniPosty": {
        "1": "šoupě",
        "98": "jiné",
    },
    "TypPovrchovehoZnakuTI": {
        "1": "šachta vstupní",
        "2": "šachta kabelovodní",
        "3": "zařízení elektrické sítě",
        "4": "zařízení sítě EK",
        "5": "zařízení plynovodní sítě",
        "6": "objekt vodovodní sítě",
        "7": "objekt stokové sítě",
        "8": "zařízení sítě produktovodu",
        "9": "zařízení teplovodní sítě",
        "98": "jiný",
    },
    "TypInzenyrskeSite": {
        "1": "elektrické vedení",
        "2": "elektronická komunikace",
        "3": "plynovod",
        "4": "vodovod",
        "5": "kanalizace",
        "6": "produktovod",
        "7": "teplovod",
        "99": "nezjištěno",
    },
    "TypPKO": {
        "1": "katodická",
        "2": "elektropolarizovaná drenáž",
        "3": "anoda",
        "4": "propojovací kabeláž",
        "99": "nezjištěno",
    },
    "TypInzenyrskeSitePKO": {
        "1": "plynovod",
        "2": "vodovod",
        "3": "kanalizace",
        "4": "produktovod",
        "5": "teplovod",
        "6": "síť elektronických komunikací",
        "7": "sdílená",
        "99": "nezjištěno",
    },
    "TypJinehoZarizeniStavebTI": {
        "1": "hlásič IZS",
        "2": "reproduktor",
        "3": "venkovní hodiny",
        "4": "svítidlo",
        "5": "osvětlení",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "StavSkladkyOdpadu": {
        "1": "v provozu",
        "2": "uzavřeno",
        "99": "nezjištěno",
    },
    "TypOdpadu": {
        "1": "ostatní odpad",
        "2": "nebezpečný odpad",
        "99": "nezjištěno",
    },
    "TypZarizeniOdstranovaniOdpadu": {
        "1": "zařízení na odstraňování BRO",
        "2": "zařízení na odstraňování nebezpečného odpadu",
        "98": "jiné",
        "99": "nezjištěno",
    },
    "PovoleniNakladaniNebezpecnymOdpadem": {
        "1": "povoleno",
        "2": "bez povolení",
        "99": "nezjištěno",
    },
    "TypDrobneSakralniStavby": {
        "1": "kříž",
        "2": "boží muka",
        "3": "kaplička",
        "99": "nezjištěno",
    },
    "TypDrobneKulturniStavby": {
        "1": "kašna",
        "2": "vodotrysk, fontána",
        "3": "pomník",
        "4": "socha",
        "5": "mohyla",
        "6": "zvonice",
        "99": "nezjištěno",
    },
    "DruhPlotu": {
        "1": "dřevěný",
        "2": "drátěný",
        "3": "kovový",
        "4": "zděný",
        "5": "živý",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "DruhSchodiste": {
        "1": "vícestupňové",
        "2": "platforma s jedním stupněm",
        "99": "nezjištěno",
    },
    "TypVrtu": {
        "1": "geotermální",
        "99": "nezjištěno",
    },
    "TypNosiceTechnickehoZarizeni": {
        "1": "informační tabule",
        "2": "billboard",
        "3": "nosič kamerového systému",
        "4": "reklamní sloup",
        "5": "vlajkový stožár",
        "6": "sdružený",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "TypZemedelskePlochy": {
        "1": "orná půda",
        "2": "vinice",
        "3": "chmelnice",
        "4": "ovocný sad",
        "5": "trvalý travní porost",
        "98": "jiná",
        "99": "nezjištěno",
    },
    "TypUdrzovaneZelene": {
        "1": "městská parková zeleň",
        "2": "udržovaná travnatá a okrasná plocha",
        "3": "skupina stromů a keřů",
        "4": "silniční vegetace",
        "99": "nezjištěno",
    },
    "TypTerenniHrany": {
        "1": "hrana",
        "2": "pata",
        "99": "nezjištěno",
    },
    "TridaPresnostiPoloha": {
        "1": "třída přesnosti 1",
        "2": "třída přesnosti 2",
        "3": "třída přesnosti 3",
        "4": "třída přesnosti 4",
        "5": "třída přesnosti 5",
        "9": "přesnost nevyhovuje ani třídě přesnosti 5, nebo není známa",
    },
    "TridaPresnostiVyska": {
        "1": "třída přesnosti 1",
        "2": "třída přesnosti 2",
        "3": "třída přesnosti 3",
        "4": "třída přesnosti 4",
        "5": "třída přesnosti 5",
        "9": "přesnost nevyhovuje ani třídě přesnosti 5, nebo není známa",
    },
    "TypOPSiteProduktovodu": {
        "1": "OP produktovodu",
        "2": "OP ropovodu",
        "99": "nezjištěno",
    },
    "TypOPSiteEK": {
        "1": "OP rádiového zařízení a rádiového směrového spoje",
        "2": "OP komunikačního vedení",
        "99": "nezjištěno",
    },
    "TypOPZarizeniOdpadovehoHospodarstvi": {
        "1": "OP skládky",
        "2": "OP spalovny",
        "3": "OP zařízení BRO",
        "4": "OP zařízení na odstraňování NO",
    },
    "TypObjektuOdpadovehoHospodarstviZameru": {
        "1": "skládka odpadů",
        "2": "spalovna",
        "3": "jiné zařízení na odstraňování, využívání nebo sběr odpadů",
        "4": "odkaliště",
        "99": "neurčeno",
    },
    "TypObjektuOdpadovehoHospodarstviPS": {
        "1": "skládka odpadů",
        "2": "spalovna",
        "3": "jiné zařízení na odstraňování, využívání nebo sběr odpadů",
        "4": "odkaliště",
        "99": "neurčeno",
    },
    "TypOPPozemniKomunikace": {
        "1": "OP dálnice",
        "3": "OP silnice I. třídy",
        "4": "OP silnice II. třídy",
        "5": "OP silnice III. třídy",
        "6": "OP místní komunikace I. třídy",
        "7": "OP místní komunikace II. třídy",
    },
    "TypOPDrazniStavby": {
        "1": "OP železniční tratě",
        "2": "OP tramvajové dráhy",
        "3": "OP pozemní lanové dráhy",
        "4": "OP speciální dráhy",
        "5": "OP visuté lanové dráhy",
    },
    "TypOPLetiste": {
        "1": "OP se zákazem staveb",
        "2": "OP s výškovým omezením staveb",
        "3": "OP proti nebezpečným a klamavým světlům",
        "4": "OP se zákazem laserových zařízení",
        "5": "OP s omezením staveb vzdušných - vedení VN a VVN",
        "6": "OP hlukové",
        "7": "OP ornitologické",
    },
    "TypOPLeteckychZabezpecovacichZarizeni": {
        "1": "OP přehledového systému",
        "2": "OP radionavigačního zařízení",
        "3": "OP radiokomunikačního systému",
        "4": "OP světelného zařízení",
        "5": "OP podzemní letecké stavby",
    },
    "TypStavby": {
        "1": "podezdívka",
        "2": "rampa",
        "3": "terasa",
        "4": "komín",
        "5": "skleník",
        "6": "zahradní bazén",
        "7": "patka, deska, monolit, pilíř",
        "8": "stavba pro zpevnění povrchu",
        "9": "čelo propustku",
        "10": "drobná sakrální stavba",
        "11": "drobná kulturní stavba",
        "12": "ostatní zastřešená stavba",
        "13": "zastřešení",
        "99": "nezjištěno",
    },
    "TypZdi": {
        "1": "volně stojící",
        "2": "opěrná",
        "3": "zárubní",
        "4": "městské hradby",
        "99": "nezjištěno",
    },
    "TypDopravniStavbyNeboPlochy": {
        "1": "pozemní komunikace",
        "2": "chodník",
        "3": "cyklostezka",
        "4": "parkoviště, odstavná plocha",
        "5": "dopravní ostrůvek",
        "6": "dělící pás",
        "7": "nájezd",
        "8": "přidružená plocha pozemní komunikace",
        "9": "tramvajová dráha",
        "10": "pozemní lanová dráha",
        "11": "speciální dráha",
        "12": "manipulační plocha",
        "13": "mostní váha",
        "14": "příkop, násyp, zářez dopravní stavby",
        "15": "nástupiště",
        "16": "plocha mostní konstrukce",
        "17": "portál tunelu",
        "18": "provozní plocha tunelu",
        "19": "portál podchodu",
        "20": "provozní plocha podchodu",
        "21": "souhrnná plocha železničních drah",
        "98": "jiný",
        "99": "nezjištěno",
    },
    "TypPrirodnihoPoloprirodnihoObjektu": {
        "1": "vodní tok",
        "2": "jezero",
        "4": "zemědělská plocha",
        "5": "zahrada",
        "6": "les",
        "7": "hospodářsky nevyužívaná plocha",
        "99": "nezjištěno",
    },
    "TypVodnihoDila": {
        "9": "stupeň",
        "10": "stavebně upravené koryto",
        "11": "meliorační příkop, žlab",
        "17": "suchá nádrž",
        "18": "nádrž, zdrž se vzdouvacím objektem",
        "19": "nádrž bez vzdouvacího objektu",
        "20": "hráz",
        "21": "jez",
        "22": "štěrková přehrážka",
        "23": "protipovodňová zábrana",
        "99": "nezjištěno",
    },
    "TypOstatniPlochy": {
        "1": "důl, lom",
        "2": "plocha rekultivace",
        "3": "úložné místo těžebního odpadu",
        "4": "jiné důlní dílo, důlní stavba",
        "5": "hřiště",
        "6": "hřbitov",
        "7": "dvůr, nádvoří",
        "8": "vegetační mísa",
        "9": "rozestavěná plocha",
        "99": "nezjištěno",
    },
    "TypUzlu": {
        "1": "křižovatka",
        "2": "odpočívka",
        "3": "hraniční přechod ČR",
        "4": "hranice přívozu",
        "5": "hranice nevybudovaného úseku",
        "6": "hranice vojenského prostoru",
        "7": "konec úseku",
    },
    "TypPrubehuJineTechnologickeStavbyTI": {
        "1": "převěs trakčního trolejového vedení železniční dráhy",
        "2": "převěs trakčního trolejového vedení jiné dráhy",
        "98": "jiný",
    },
    "UmisteniOznacniku": {
        "1": "samostatný nosič",
        "2": "sdílené podpěrné zařízení",
        "3": "stavba zastřešení",
        "4": "jiné",
    },
    "DruhHromadneDopravy": {
        "1": "autobusová",
        "2": "trolejbusová",
        "3": "tramvajová",
        "4": "lanová",
        "5": "přívoz",
    },
    "TypHydrantuVodovodniSite": {
        "1": "garantovaný",
        "2": "obecný",
        "99": "nezjištěno",
    },
    "DimenzeHydrantuVodovodniSite": {
        "1": "DN 80",
        "2": "DN 100",
        "3": "DN 125",
        "4": "DN 150",
        "5": "DN 200",
        "98": "jiná",
        "99": "nezjištěno",
    },
};
export const BOOLEAN_ATTRS = [
    "HraniceJinehoObjektu",
    "NeuplnaData",
    "OchrannaFunkce",
];
//# sourceMappingURL=enum-labels.js.map